import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }
  const demoToken = sessionStorage.getItem('msal.demo.token');
  if (demoToken) {
    return true;
  }

  return false;
};
